import ApiService from '@/services/apiService';
import tenantPickerMixin from '@/components/core/tenant/pickerMixin';
import { mapState, mapGetters } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'ViewAccountMgmtAccountMgmtAnnouncement',
  mixins: [tenantPickerMixin],
  data() {
    return {
      formIsValid: false,
      maintenance: {
        start: new Date(),
        end: new Date(new Date() - -7 * 86400 * 1000),
        active: true,
        type: 'info',
        message: null,
        includeSubTenants: false,
        presentationType: 'banner',
        link: {
          url: null,
          message: this.$i18n_t('accMgmt.announcement.linkMessage')
        }
      },
      announcements: [],
      announcementsTbl: null,
      addAnnouncement: false,
      tableLoading: false,
      announcementSearch: null
    };
  },
  computed: {
    ...mapState('app', ['UiTheme']),
    ...mapGetters({
      sessionUser: 'authentication/user'
    }),
    buttons() {
      return [{
        icon: 'fal fa-plus',
        action: 'add',
        title: this.$i18n_t('accMgmt.announcement.announcementCreate')
      }];
    }
  },
  watch: {
    selectedTenantId() {
      this.fetchAllSystemAnnouncements();
    }
  },
  mounted() {
    this.loadTenants();
  },
  methods: {
    closeDialog() {
      this.resetDialog();
    },
    revalidateForm() {
      this.$refs.mainForm.validate();
    },
    saveAnnouncement(data) {
      let announcementData = this.checkAnnouncementData(data);
      if (announcementData.message) {
        if (announcementData.id) {
          this.updateAnnouncement(announcementData);
        } else {
          this.createSystemAnnouncement(announcementData);
        }
      }
    },
    maintenanceToggleDate() {
      if (!!this.maintenance.start) {
        delete this.maintenance.start;
      } else {
        this.maintenance.start = new Date();
      }
      this.maintenance = cloneDeep(this.maintenance);
    },
    maintenanceDatePicked(dateObject) {
      this.maintenance.start = new Date(dateObject.from * 1000);
    },
    createSystemAnnouncement(data) {
      return ApiService.tenantCreateSystemAnnouncement(this.selectedTenantId, data).then(() => {
        this.$snack(this.$i18n_t('accMgmt.announcement.announcementCreated'), 'success');
        this.handler();
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('accMgmt.announcement.announcementCreatedFaild'), 'error');
        }
      });
    },
    fetchAllSystemAnnouncements() {
      ApiService.tenantFetchAllSystemAnnouncement(this.selectedTenantId).then(systemAnnouncements => {
        this.announcements = systemAnnouncements;
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('accMgmt.announcement.errorFindingAnnouncement'), 'error');
        }
      });
    },
    openEditDialog(announcement) {
      this.maintenance = announcement;
      this.addAnnouncement = true;
    },
    updateAnnouncement(announcement) {
      ApiService.tenantUpdateSystemAnnouncement(this.selectedTenantId, announcement).then(() => {
        this.$snack(this.$i18n_t('accMgmt.announcement.announcementUpdated'), 'success');
        this.handler();
      }).catch(error => {
        console.error(error);
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('accMgmt.announcement.announcementUpdatedFail'), 'error');
        }
      });
    },
    deleteAnnouncement(announcement) {
      ApiService.tenantDeleteSystemAnnouncement(announcement.id).then(() => {
        this.$snack(this.$i18n_t('accMgmt.announcement.announcementDeleted'), 'success');
        this.removeFromUser(announcement);
        this.handler();
      }).catch(error => {
        console.error(error);
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('accMgmt.announcement.announcementDeletedFail'), 'error');
        }
      });
    },
    resetDialog() {
      this.addAnnouncement = false;
      this.maintenance = {
        start: new Date(),
        end: new Date(new Date() - -7 * 86400 * 1000),
        active: true,
        type: 'info',
        message: null,
        includeSubTenants: false,
        presentationType: 'banner',
        link: {
          url: null,
          message: this.$i18n_t('accMgmt.announcement.linkMessage')
        }
      };
      this.fetchAllSystemAnnouncements();
    },
    checkAnnouncementData(data) {
      if (!data.link.url) {
        data.link.message = null;
      }
      return data;
    },
    removeFromUser(announcement) {
      if (!this.sessionUser.properties) {
        return;
      }
      this.sessionUser.properties.announcements = this.sessionUser.properties.announcements.filter(a => parseInt(a) !== parseInt(announcement.id));
      return ApiService.updateUser(this.sessionUser);
    },
    getUserAnnouncements() {
      ApiService.getUserAnnouncements().then(result => {
        const now = new Date();
        this.$store.state.app.announcements = result.map(announcement => {
          // if expired set state to inactive
          const endDate = new Date(announcement.end);
          if (announcement.end && endDate < now && this.selectedTenantId) {
            ApiService.tenantUpdateSystemAnnouncementState(this.selectedTenantId, announcement);
            return null;
          }
          if (announcement && announcement.active) {
            return {
              ...announcement
            };
          }
          return null;
        }).filter(a => !!a);
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('accMgmt.announcement.errorFindingUserAnnouncements'), 'error');
        }
        console.error(error);
      });
    },
    handler() {
      this.getUserAnnouncements();
      this.resetDialog();
    }
  }
};